import { DeviationTeamTypeStrategyDTO, EnumModel } from "api/swagger/ApiClient";
import { UserContact } from "model/business-types";
import { SystemUserWrapper } from "model/support-types";
import { DeviationTeamRegionDirectorDataModel } from "./deviation-team-region-director-model";

export interface DeviationTeamModel {
  data: DeviationTeamDataModel;
  membersWrapper: SystemUserWrapper[];
  regionDirectors: DeviationTeamRegionDirectorDataModel[];
  isEditing(): boolean;
}

export interface DeviationTeamDataModel {
  id: number;
  name: string;
  teamType: EnumModel;
  teamStrategy: DeviationTeamTypeStrategyDTO;
  emailAddress: string | null;
  teamLeader: UserContact | null;
}
